export default "__VITE_ASSET__BCUqgsa2__"